import type { EmailCompositionValue } from '@kula-ai/components';
import type { SelectOption } from '@kula-ai/components';
import { WHITESPACE_GLOBAL_REGEX } from '@/constants/regex';

const EDITED_SUFFIX = ' (edited)';

function normalizeForCompare(html: string): string {
  return html.replace(WHITESPACE_GLOBAL_REGEX, ' ').trim();
}

function optionDisplayName(opt: SelectOption | undefined): string {
  if (!opt) {
    return '';
  }
  const fromLabel = typeof opt.label === 'string' ? opt.label.trim() : '';
  const fromData =
    opt.data &&
    typeof opt.data === 'object' &&
    opt.data !== null &&
    'name' in opt.data &&
    typeof (opt.data as { name?: unknown }).name === 'string'
      ? String((opt.data as { name: string }).name).trim()
      : '';
  return fromLabel || fromData;
}

/**
 * `name` for calendar-invite template attributes: template label, `label + " (edited)"` when body
 * diverges from the template HTML, or empty when no template is selected.
 */
export function calendarInviteTemplateNameForApi(
  value: EmailCompositionValue,
  templateOptions: SelectOption[]
): string {
  const tplId = value.template;
  if (!tplId) {
    return '';
  }
  const opt = templateOptions.find((o) => String(o.value) === String(tplId));
  const displayName = optionDisplayName(opt);
  const tplBody =
    opt?.data &&
    typeof opt.data === 'object' &&
    opt.data !== null &&
    typeof (opt.data as { body?: unknown }).body === 'string'
      ? (opt.data as { body: string }).body
      : '';
  const current = typeof value.content === 'string' ? value.content : '';

  const sameBody =
    normalizeForCompare(tplBody) === '' ||
    normalizeForCompare(current) === normalizeForCompare(tplBody);

  if (!displayName) {
    return sameBody ? '' : EDITED_SUFFIX.trim();
  }
  return sameBody ? displayName : `${displayName}${EDITED_SUFFIX}`;
}
